module.exports = __webpack_public_path__ + "img/top-left-arrow.97d13528.svg";